import { Box } from "@chakra-ui/layout";
import { Col } from "antd";
import { ComposicaoItem } from "features/conta/typings";
import { Control, UseFormSetValue } from "react-hook-form";
import Field from "components/Input/Field";
import InputMoney from "components/Input/InputMoney";
import SelectContaCategoria from "components/Input/SelectContaCategoria";
import { InputBaseWrapper } from "./InputBaseWrapper";
import { OperacaoEnum } from "resources/enums/conta";

interface FormItemCategoriaFinanceiraProps {
  operacao: OperacaoEnum;
  control: Control<ComposicaoItem>;
  setValue: UseFormSetValue<ComposicaoItem>;
}

function FormItemCategoriaFinanceira({
  operacao,
  control,
  setValue,
}: FormItemCategoriaFinanceiraProps) {
  return (
    <>
      <InputBaseWrapper gutter={32}>
        <Box as={Col} xs={16}>
          <Field
            control={control}
            name="categoriaFinanceiraId"
            label="Conta categoria"
            rules={{ required: "Campo obrigatório" }}
            render={({ field, isInvalid }) => (
              <SelectContaCategoria
                value={field.value}
                placeholder="Selecione..."
                onChange={(v, item) => {
                  field.onChange(v);
                  setValue("operacao", item.operacao);
                  setValue("centroDeCustoId", item.centroDeCustoId);
                }}
                isInvalid={isInvalid}
                operacao={
                  operacao === OperacaoEnum.Despesa ? operacao : undefined
                }
                disableNotClassifiableNodes
              />
            )}
          />
        </Box>

        <Box as={Col} xs={8}>
          <Field
            control={control}
            name="valor"
            label="Valor líquido"
            rules={{ required: "Campo obrigatório" }}
            render={({ field, isInvalid }) => (
              <InputMoney
                isInvalid={isInvalid}
                onChange={field.onChange}
                value={field.value}
                minValue={0}
              />
            )}
          />
        </Box>
      </InputBaseWrapper>
    </>
  );
}

export default FormItemCategoriaFinanceira;
